export function getEndNextCalendarMonthIsh(): Date {
  const now = new Date();

  if (now.getDate() < 5) {
    return new Date(now.getFullYear(), now.getMonth() + 1, 1);
  }

  return new Date(now.getFullYear(), now.getMonth() + 2, 0);
}
